module.exports = __webpack_public_path__ + "static/media/10.3e72c173.png";